<div class="d-flex justify-content-center justify-content-md-start">
  <div class="d-flex flex-column flex-md-row-reverse">
    @if (viewModel.primaryButton) {
      <a
        class="btn btn-primary mt-2"
        [ngClass]="{ 'ml-md-2 ml-0': viewModel.secondaryButton }"
        data-e2e="add-contract"
        [href]="viewModel.primaryButton.link | link | async"
        (click)="doClickPrimaryButtonLink(); (false)"
        [ecmDisabledAction]="isDisabledEclairPrimaryButtonLink"
      >
        {{ viewModel.primaryButton.label }}
      </a>
    }
    @if (viewModel.secondaryButton) {
      <a
        class="btn btn-secondary mt-2"
        data-e2e="e-sim"
        [href]="viewModel.secondaryButton.link | link | async"
        (click)="doClickSecondaryButtonLink(); (false)"
        [ecmDisabledAction]="isDisabledEclairSecondaryButtonLink"
      >
        {{ viewModel.secondaryButton.label }}
      </a>
    }
  </div>
</div>
